import React, { Component } from 'react'
import autoBind from 'react-autobind'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Container, Grid, Image, Message } from 'semantic-ui-react'

import logo from '../../assets/images/logo.png'
import { tr } from '../../helpers/languages'

class NotFound extends Component {
    constructor (props) {
        super(props)
        this.state = {}
        autoBind(this)
    }

    render () {
        return (
            <Container className='not-found'>
                <Link to='/'>
                    <Image className='logo' src={logo} centered/>
                </Link>
                <Grid className='segment centered'>
                    <Message error>{tr('PAGE_NOT_FOUND')}</Message>
                </Grid>
            </Container>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        language: state.settings.language
    }
}

const mapDispatchToProps = (_dispatch) => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(NotFound)



// WEBPACK FOOTER //
// ./src/components/not-found/index.js